import { Chip, Typography } from '@material-ui/core';
import { useStyles } from '../../../../styles';

interface ActionCardTitleRowProps {
  title: string;
  itemsCount: number;
  badgeLabel: string;
  priority?: 'High' | 'Medium' | 'Low';
}

function formatWorkItemTypeLabel(value: string) {
  if (value === 'userStory') return 'user stories';
  if (value === 'testCase') return 'Test Cases';
  if (value === 'regressionRun') return 'Regression Freq';
  if (value === 'bug') return 'Bugs';
  return value;
}

export function ActionCardTitleRow({
  title,
  itemsCount,
  badgeLabel,
  priority,
}: ActionCardTitleRowProps) {
  const classes = useStyles();
  const priorityClassName =
    priority === 'High'
      ? classes.actionCardPriorityHigh
      : priority === 'Medium'
      ? classes.actionCardPriorityMedium
      : classes.actionCardPriorityLow;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Typography variant="body2">{title}</Typography>
      <Chip
        size="small"
        className={classes.actionTypeLabelChip}
        label={
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {formatWorkItemTypeLabel(badgeLabel)}
            <span className={classes.actionCardCountChip}>{itemsCount}</span>
          </span>
        }
      />

      {priority && (
        <Chip
          size="small"
          label={`${priority} Priority`}
          className={priorityClassName}
        />
      )}
    </div>
  );
}
